<template>
  <div>
    <a-card title="Sending Stats">
      <div class="sending-stats-flex">
        <div>
          <strong>Created</strong>
          <br>
          <small style="color:green">{{timeConversion(stats.created_at)}}</small>
        </div>
        <div>
          <strong>Queued</strong>
          <br>
          <small style="color:green">{{timeConversion(stats.queued_at)}}</small>
        </div>
        <div>
          <strong>Dispatched</strong>
          <br>
          <small style="color:green">{{timeConversion(stats.dispatched_at)}}</small>
        </div>
        <div>
          <strong>Sending Started</strong>
          <br>
          <small style="color:green">{{timeConversion(stats.sending_started_at)}}</small>
        </div>
        <div>
          <strong>Finished</strong>
          <br>
          <small style="color:green">{{timeConversion(stats.sending_finished_at)}}</small>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["stats"],
  methods: {
    timeConversion(time) {
      if (time) {
        return moment.unix(time).format("YY-MM-DD H:m:s A");
      } else {
        return "---------";
      }
    }
  },
  mounted() {}
};
</script>

<style>
.sending-stats-flex {
  display: flex;
  text-align: center;
  justify-content: space-around;
}
.sending-stats-flex div {
  border-right: 2px solid #f1f1f1;
  padding-right: 40px;
}
.sending-stats-flex div:last-child {
  border-right: none;
}
</style>


